@if (isLoading()) {
  <div class="min-h-screen bg-[#fafaf7] flex items-center justify-center font-sans">
    <div class="flex flex-col items-center gap-4">
      <div class="relative w-12 h-12">
        <div class="absolute inset-0 rounded-full border-4 border-stone-200"></div>
        <div class="absolute inset-0 rounded-full border-4 border-t-primary-400 animate-spin"></div>
      </div>
      <p class="text-stone-600 font-medium text-sm">Chargement…</p>
    </div>
  </div>
} @else if (accessLevel() === 'blocked') {
  <div class="min-h-screen bg-[#fafaf7] flex items-center justify-center font-sans px-6">
    <div class="max-w-lg w-full bg-white border border-stone-100 rounded-3xl shadow-sm p-10 text-center">
      <h1 class="text-xl font-semibold text-stone-900">Accès non autorisé</h1>
      <p class="mt-2 text-sm text-stone-600">Votre compte club est désactivé. Veuillez contacter votre fédération.</p>
    </div>
  </div>
} @else {
  <div class="min-h-screen bg-[#fafaf7] flex">
    <app-sidebar [club]="club()"></app-sidebar>

    <div class="flex-1 flex flex-col min-w-0">
      <div class="sticky top-0 z-30">
        <app-header [federationLogoUrl]="federationLogoUrl()" [accessLevel]="accessLevel()" (logoutEvent)="logout()"></app-header>
      </div>

      <main class="flex-1">
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>
}
